import { AuditLog } from '@features/audit';

export function AuditPage() {
  return <AuditLog />;
}
